import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import Can from '../../../components/Can';
import { useTranslation } from "react-i18next";
import SideBarSubMenuItem from '../SideBarSubMenuItem';
import SideBarMenuCollapseItem from '../SideBarMenuCollapseItem';
import { observer } from 'mobx-react-lite';
import { useStores } from '../../../stores';

const SideBarCartMenu = observer(() => {
    const { t } = useTranslation();
    const { configurationStore } = useStores();

    const isCartsMenuEnabled = configurationStore.isCartWitnessingFeatureEnabled();
    if (!isCartsMenuEnabled) {
        return null;
    }

    return (
        <Can do="read" on='Cart'>
            <SideBarMenuCollapseItem icon={<DocumentScannerOutlinedIcon />} type="carts" text={t("carts")}>
                <SideBarSubMenuItem id="side_menu_item_carts" to='/carts' text={t("carts")} />
                <SideBarSubMenuItem id="side_menu_item_carts_places" to='/carts/places' text={t("places")} />
                <SideBarSubMenuItem id="side_menu_item_carts_approved" to='/carts/approved' text={t("approved")} />
                <SideBarSubMenuItem id="side_menu_item_carts_statistics" text={t("statistics")} disabled />
            </SideBarMenuCollapseItem>
        </Can>
    );
});

export default SideBarCartMenu;
